import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { toastError, toastSuccess } from '@components/Toast';
import CommonImage from '@components/CommonImage';

import { getGroupPoData } from '@features/order/utils/projectUtil';
import ColorSizeBreakDownTable from '@features/order/components/orderInfo/ColorSizeBreakDownTable';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';

import { fetchEnumValues } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { renderSetImages, STATIC_SET_CONSTANTS } from '@utils/Util';

const AddStyleFromCurrentOrder = ({
	orderId,
	isDrafted,
	hideStatusType,
	poItemIdentifier,
	productRefNumber,
	newlyAddedStyle,
	onRemoveStyles,
	onAddSuccess,
	getProjectDetails,
	pOSegmentationType
}) => {
	const dispatch = useDispatch();
	const [orderStyles, setOrderStyles] = useState([]);
	const [isOverflow, setIsOverflow] = useState(false);

	const [groupData, setGroupData] = useState(null);

	const [, setSeasons] = useState([]);
	const [, setSetPackStyleFlag] = useState([]);
	const [designIdList, setDesignIdList] = useState([]);
	const [, setRemovedColorIds] = useState([]);
	const [, setProductWiseColorIds] = useState({});

	const [errorDesign, setErrorDesign] = useState({});
	const [, setIsPlacingOrder] = useState(false);

	const [, setOpenAccordion] = useState([]);

	const inputRefs = useRef([]);

	useEffect(() => {
		setOrderStyles(newlyAddedStyle);
	}, [newlyAddedStyle]);

	useEffect(() => {
		const allProductRefNumbers = groupData?.map((item) => item.productReferenceNumber);
		setOpenAccordion(allProductRefNumbers);
	}, [groupData]);

	const handleAccordionClick = (productRefNumber) => {
		setOpenAccordion((prevState) => {
			const newState = prevState.includes(productRefNumber)
				? prevState.filter((ref) => ref !== productRefNumber)
				: [...prevState, productRefNumber];
			return newState;
		});
	};

	useEffect(() => {
		if (productRefNumber) {
			const element = document.getElementById(productRefNumber);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		}
	}, [productRefNumber]);
	useEffect(() => {
		if (orderStyles) {
			let ids = orderStyles.map((item) => item.productId);
			setDesignIdList(ids);
			if (!isDrafted) {
				let quotationColorIds = [];
				let productColorIds = [];
				orderStyles
					.map((styleItem) => styleItem.colorWiseSizeQuantityPairList)
					.forEach((colorItem) => {
						if (colorItem) {
							quotationColorIds.push(...colorItem.map((singleItem) => singleItem.id));
						}
					});
				orderStyles
					.map((styleItem) => styleItem?.productColorIds)
					.forEach((colorIds) => {
						if (colorIds) {
							productColorIds.push(...colorIds);
						}
					});

				let removedColorIds = productColorIds
					.filter((id) => !quotationColorIds.includes(id))
					.map((id) => parseInt(id));
				setRemovedColorIds(removedColorIds);
			} else {
				let productWiseColorIds = {};
				orderStyles.map((styleItem) => {
					productWiseColorIds[styleItem.productId] = styleItem.colorWiseSizeQuantityPairList?.map(
						(colorId) => colorId.id
					);
				});
				setProductWiseColorIds(productWiseColorIds);
			}
		}
	}, [orderStyles]);

	useEffect(() => {
		setGroupData(getGroupPoData(filterStylesData()));
	}, [orderStyles, hideStatusType]);

	const onPlaceOrder = async () => {
		setErrorDesign({});
		setIsPlacingOrder(true);
		dispatch(openLoader());
		await ApiClient.POST('addStyleToOrder', orderStyles, `${orderId}/add-style`)
			.then(({ data }) => {
				dispatch(closeLoader());
				setIsPlacingOrder(false);
				getProjectDetails(orderId);
				if (data.success) {
					toastSuccess(data.message);
					onAddSuccess();
				} else {
					toastError(data.message);
				}
			})
			.catch(({ response }) => {
				setIsPlacingOrder(false);
				dispatch(closeLoader());
				if (response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	useEffect(() => {
		(async () => {
			try {
				await fetchEnumValues('info.nitex.app.product.SetPackStyleFlag', setSetPackStyleFlag);
				await fetchEnumValues('info.nitex.app.materials.Season', setSeasons);
			} catch {}
		})();
	}, []);

	const onChangePO = (array, id, keyPath, value) => {
		const updatedArray = array.map((item) => {
			if (item.id === id) {
				const updatedItem = {
					...item,
					rfqId: id,
					[keyPath]: value
				};

				return updatedItem;
			}
			return item;
		});
		setOrderStyles(updatedArray);
		setGroupData(getGroupPoData(updatedArray));
		return updatedArray;
	};
	const handleFocus = (index) => {
		// Focus the input field at the given index
		if (inputRefs.current[index]) {
			inputRefs.current[index].focus();
		}
	};

	const onCloseViewModal = () => {
		dispatch(clearDesignViewModalInfo({}));
	};
	const openDesignViewModal = (item) => {
		dispatch(
			setDesignViewModalInfo({
				isShowMergeTechPack:
					item?.isSet || item?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT,
				id: item?.productId,
				onCloseViewModal: onCloseViewModal,
				source: 'PRODUCT_LIST',
				designIdList: designIdList
			})
		);
	};
	const filterStylesData = () => {
		if (hideStatusType) {
			return orderStyles.filter((item) => {
				switch (hideStatusType) {
					case 'piCreated':
						return item.isPiCreated === true;
					case 'piPending':
						return item.isPiCreated === false;
					case 'scCreated':
						return item.isScCreated === true;
					case 'scPending':
						return item.isScCreated === false;
					case 'tnaCreated':
						return item.isTNACreated === true;
					case 'tnaPending':
						return item.isTNACreated === false;
					default:
						return true;
				}
			});
		} else {
			return orderStyles;
		}
	};
	const isDisabledSubmitButton = (array) => {
		//draftStatus: "COMPLETED" for all array then it will return false other wise true
		return array.some((item) => item.draftStatus !== 'COMPLETED');
	};

	if (!groupData) {
		// Show a loading spinner or placeholder while data is being initialized
		return <div>Loading...</div>;
	}

	return (
		<>
			<>
				<h3 className="semibold-14 pt-2">New style added</h3>
				<div className="accordion" id="accordionExample">
					{groupData?.map((item, index) => (
						<div
							className={`card ${isOverflow ? 'overflow-visible' : ''} ${index === groupData.length - 1 ? 'last-card' : ''} ${!isDisabledSubmitButton(item?.poData) ? 'active' : ''}`}
							key={`new_style_card_${index}`}
						>
							<div className="card-header">
								<h2 className="mb-0">
									<button
										className="btn btn-link btn-block d-flex justify-content-between align-items-center text-left gray_dark_01 regular-14 weight-600 p-0"
										type="button"
										onClick={() => handleAccordionClick(item?.productReferenceNumber)}
									>
										<div className="d-flex align-items-center">
											<div className="order-header-img mr-2">
												<CommonImage isStatic={false} src={item?.imgUrl} />
											</div>
											<p className="medium-14">
												{item.productReferenceNumber}{' '}
												<span className="regular-12 gray_dark_02">
													({item?.name})
												</span>
												{!isDisabledSubmitButton(item?.poData) && (
													<CommonImage
														src="/icons/check-bg-green.svg"
														className="ml-2"
														alt=""
														width="18"
													/>
												)}
											</p>
										</div>

										<div className="arrow-down">
											<CommonImage
												src="/icons/down-arrow-gray-dark-02.svg"
												alt=""
												width="18"
											/>
										</div>
									</button>
								</h2>
							</div>

							<div className={`collapse show`}>
								{item?.poData.map((singlePo, index) => (
									<div
										key={singlePo.id}
										className={`card-body border-0 designs-info-section mt-0 radius-6 ${singlePo.draftStatus === 'COMPLETED' && isDisabledSubmitButton(item?.poData) ? 'active' : ''}`}
									>
										<div className="designs-row order-desing-row">
											<div
												className={`single-design p-0 m-0 border-0 ${!singlePo.isBaseRfq && 'd-block'}`}
											>
												{singlePo.isBaseRfq && (
													<div className="single-design-card with-editable">
														<div className="card-top">
															<div className="edit-items">
																<div className="select-and-edit d-flex justify-content-between">
																	<div className="custom-chekbox">
																		<div className="form-group cursor-pointer">
																			<CommonImage
																				src={`/icons/delete_gray.svg`}
																				alt="delete"
																				className="delete-button add-to-favorite"
																				onClick={(e) => {
																					e.stopPropagation();
																					onRemoveStyles(
																						singlePo.productId
																					);
																				}}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															<>
																{singlePo?.isSet ? (
																	<div
																		onClick={() =>
																			openDesignViewModal(singlePo)
																		}
																	>
																		{renderSetImages(
																			singlePo?.documentResponseList,
																			'100%'
																		)}
																	</div>
																) : (
																	<CommonImage
																		src={
																			singlePo?.documentResponseList[0]
																				?.docUrl
																		}
																		alt={singlePo.name}
																		isStatic={false}
																		onClick={() =>
																			openDesignViewModal(singlePo)
																		}
																	/>
																)}
															</>
														</div>
													</div>
												)}
												<div className="title-and-form">
													{!singlePo.isBaseRfq && (
														<div className="split-order-form d-block">
															<div className="single-design-input">
																<div className="row">
																	<div className="col-md-4 ">
																		<div className="form-group mb-2">
																			<label for="design-no">
																				PO received date
																			</label>
																			<input
																				type="date"
																				placeholder="02/05/2024"
																				id=""
																				value={singlePo.poReceiveDate}
																				onChange={(e) =>
																					onChangePO(
																						orderStyles,
																						singlePo.id,
																						'poReceiveDate',
																						e.target.value
																					)
																				}
																			/>
																		</div>
																	</div>
																	<div className="col-md-4">
																		<div className="form-group mb-2">
																			<label for="po-no">
																				ETD (dd/mm/yyyy)
																			</label>
																			<input
																				type="date"
																				id=""
																				placeholder="02/05/2024"
																				value={singlePo.deliveryDate}
																				onChange={(e) =>
																					onChangePO(
																						orderStyles,
																						singlePo.id,
																						'deliveryDate',
																						e.target.value
																					)
																				}
																			/>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													)}

													{/* {singlePo.isEdit ? ( */}
													{singlePo.isBaseRfq && (
														<div className="split-order-form pt-4">
															<div className="single-design-input">
																<div className="row">
																	<div className="col-md-12 p-0">
																		<div className="form-group mb-2">
																			<label for="design-no">
																				Design No
																			</label>
																			<input
																				ref={(el) =>
																					(inputRefs.current[
																						index
																					] = el)
																				}
																				type="text"
																				placeholder="Design No"
																				name="productReferenceNumber"
																				id={`productReferenceNumber_${singlePo.id}`}
																				value={
																					singlePo.productReferenceNumber
																				}
																				onChange={(e) =>
																					onChangePO(
																						orderStyles,
																						singlePo.id,
																						'productReferenceNumber',
																						e.target.value
																					)
																				}
																				onFocus={() =>
																					handleFocus(index)
																				}
																			/>
																		</div>
																	</div>
																	<div className="col-md-12 p-0">
																		<div className="form-group mb-2">
																			<label for="po-no">PO No</label>
																			<input
																				type="text"
																				id=""
																				placeholder="PO No"
																				value={singlePo.poNumber}
																				onChange={(e) =>
																					onChangePO(
																						orderStyles,
																						singlePo.id,
																						'poNumber',
																						e.target.value
																					)
																				}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															<div className="single-design-input">
																<div className="row">
																	<div className="col-md-12 p-0">
																		<div className="form-group mb-2">
																			<label for="design-no">
																				PO received date
																			</label>
																			<input
																				type="date"
																				placeholder="02/05/2024"
																				id=""
																				value={singlePo.poReceiveDate}
																				onChange={(e) =>
																					onChangePO(
																						orderStyles,
																						singlePo.id,
																						'poReceiveDate',
																						e.target.value
																					)
																				}
																			/>
																		</div>
																	</div>
																	<div className="col-md-12 p-0">
																		<div className="form-group mb-2">
																			<label for="po-no">
																				ETD (dd/mm/yyyy)
																			</label>
																			<input
																				type="date"
																				id=""
																				placeholder="02/05/2024"
																				value={singlePo.deliveryDate}
																				onChange={(e) =>
																					onChangePO(
																						orderStyles,
																						singlePo.id,
																						'deliveryDate',
																						e.target.value
																					)
																				}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															<div className="single-design-input">
																<div className="row">
																	{(singlePo?.isPack ||
																		singlePo?.isSet) && (
																		<div className="col-md-12 p-0">
																			<div className="form-group composition-item mb-0">
																				<label>UOM</label>
																				<div className="d-flex composition-and-qty">
																					<input
																						type="text"
																						className="input-percentage"
																						placeholder={
																							singlePo?.isPack
																								? 'Pack'
																								: singlePo?.isSet
																									? 'Set'
																									: ''
																						}
																						onChange={(e) =>
																							onChangePO(
																								orderStyles,
																								singlePo.id,
																								'unitOfMeasurementType',
																								e.target.value
																							)
																						}
																						value={
																							singlePo?.isPack
																								? 'Pack'
																								: singlePo?.isSet
																									? 'Set'
																									: ''
																						}
																						disabled={true}
																					/>

																					<div className="select-component">
																						<div className="form-group size36">
																							<div className="select-component">
																								<input
																									type="number"
																									min="0.1"
																									max="100"
																									className="w-100"
																									placeholder="Write qty"
																									onChange={(
																										e
																									) =>
																										onChangePO(
																											orderStyles,
																											singlePo.id,
																											'unitOfMeasurementQty',
																											e
																												.target
																												.value
																										)
																									}
																									value={
																										singlePo.unitOfMeasurementQty
																									}
																								/>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
																</div>
															</div>
														</div>
													)}
												</div>
											</div>
											<ColorSizeBreakDownTable
												item={{ ...singlePo, isEdit: true }}
												stylesData={orderStyles}
												setOrderStyles={setOrderStyles}
												quoteId={singlePo.id}
												isDrafted={true}
												error=""
												errorDesign={errorDesign}
												setIsOverflow={setIsOverflow}
												poItemIdentifier={poItemIdentifier}
												isDisabled={false}
												pOSegmentationType={pOSegmentationType}
											/>
										</div>
									</div>
								))}
							</div>
						</div>
					))}
					<div className="footer-button text-right mb-2">
						<button className="button size32" onClick={onPlaceOrder}>
							Submit
						</button>
					</div>
				</div>
			</>
		</>
	);
};

export default AddStyleFromCurrentOrder;
